import moment from "moment";
import { setLoading, unsetLoading } from "../../../store/loading/loading.slice";
import { useCallback, useEffect, useState } from "react";
import TableRowCommon from "../../../components/table/TableRowCommon";
import { IconButton, useMediaQuery, useTheme } from "@mui/material";
import { useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import { NavigateFunction, useNavigate } from "react-router-dom";
import { routeName } from "../../../routes/routeName";
import { InterviewStudentApi } from "../../../api/interview-student/interview-student.api";
import { AdmissionAdminApi } from "../../../api/admission_admin/admission_admin.api";
import _ from "lodash";
import { alertError, alertSuccess, swalError } from "../../../components/alert/swal";
import StatusCustom from "../../../components/status/statusCustom";
import { renderStatus } from "../history-online-Admission/enum/admission.enum";
import { degreeApi } from "../../../api/degree/degree.api";
import { facultyApi } from "../../../api/factulty/factulty.api";
import InputTextField from "../../../components/input/inputTextField";
import { getFileExtension } from "../../../utils/fileTypeDownload";
import saveAs from "file-saver";
const ManageState = () => {
    const { t } = useTranslation();
    const theme = useTheme()
    const matches = useMediaQuery(theme.breakpoints.up("md"));
    const navigate: NavigateFunction = useNavigate();

    const dispatch = useDispatch();
    const [page, setPage] = useState<number>(1);
    const [pageLimit, setPageLimit] = useState<number>(10);
    const [totalItems, setTotalItems] = useState<number>(0);
    const [sortBy, setSortBy] = useState<string>("modified_date");
    const [sortType, setSortType] = useState<string>("DESC")
    const [keyword, setKeyword] = useState<string>("");
    const [status, set_status] = useState<string>("ALL");
    const [degree, setDegree] = useState<any[]>([]);
    const [faculty, setFaculty] = useState<any[]>([]);
    const [id_degree, set_id_degree] = useState<any>("ALL");
    const [id_faculty, set_id_faculty] = useState<any>("ALL");
    const [showModal, setShowModal] = useState<string>("");
    const [student_no, set_student_no] = useState<any>();
    // const [url_payment_term, set_url_payment_term] = useState<any>();


    const [data, setData] = useState<any[]>([]);
    const [startDate, setStartDate] = useState<string>("");
    const [endDate, setEndDate] = useState<string>("");
    const [date_range, set_date_range] = useState<string[]>([]);
    const [isChecks, setIsChecks] = useState<any[]>([]);
    const [isCheckAll, setIsCheckAll] = useState<string>("");

    const onCheck = (event: any) => {
        const { checked, value } = event;
        if (checked) {
            setIsChecks((prev) => [...prev, data.find((item) => Number(item?.id_admission_student) === Number(value))]);
            // setFormInterview((prev: any) => [...prev, data?.filter((item: any) => item?.admission_status === "INTERVIEW_SUCCESS")?.find((item: any) => item?.id_admission_student === Number(value))])

        } else {
            setIsChecks((prev) => prev.filter((x) => Number(x?.id_admission_student) !== Number(value)));
            // setFormInterview((prev: any) => [...prev, data?.filter((item: any) => item?.admission_status === "INTERVIEW_SUCCESS")?.find((item: any) => item?.id_admission_student === Number(value))])


        }
    };
    const onCheckAll = (event: any) => {
        const { checked } = event;
        const id = data?.filter((item: any) => item?.admission_status === "INTERVIEW_SUCCESS")
        if (checked) {
            setIsChecks(Array.from(new Set([...isChecks, ...id])));
            // setFormInterview(Array.from(new Set([...data?.filter((item: any) => item?.admission_status !== "INTERVIEW_SUCCESS"), ...formInterview])))

        } else {
            setIsChecks([]);
            // setFormInterview([]);
            // setIsChecks(_.filter(isChecks, (i) => !_.includes(id, i)));
        }
    };
    const handleOnCheckAll = () => {
        const hasSome = _.some(data?.filter((item: any) => item?.admission_status === "INTERVIEW_SUCCESS"), (i: any) =>
            _.some(isChecks, (j: any) => Number(i?.id_admission_student) === Number(j?.id_admission_student))
        );
        const hasAll = _.every(data?.filter((item: any) => item?.admission_status === "INTERVIEW_SUCCESS"), (i: any) =>
            _.some(isChecks, (j: any) => Number(i?.id_admission_student) === Number(j?.id_admission_student))
        );
        if (!_.isEmpty(isChecks) && !hasAll && hasSome)
            setIsCheckAll("indeterminate");
        else if (!_.isEmpty(isChecks) && hasAll) setIsCheckAll("checked");
        else setIsCheckAll("");
    };


    useEffect(() => {
        handleOnCheckAll();
    }, [isChecks]);

    const handleChangeDateRange = (date_value: string[]) => {
        set_date_range(date_value);
        setStartDate(date_value[0]);
        setEndDate(date_value[1]);
    }
    const handleClearDateRange = () => {
        set_date_range([]);
        setStartDate("");
        setEndDate("");
    }
    const handleRequestSort = (sortBy: string, sortType: string) => {
        setSortBy(sortBy)
        setSortType(sortType)
    }

    const handleCloseModal = () => {
        setShowModal("");
        set_student_no('')
        setIsCheckAll('')
        setIsChecks([])
        // set_url_payment_term('')
    }
    const headCells = [
        {
            id: "id_admission_student",
            disablePadding: false,
            label: "CHECKBOX",
            align: "end",
            // disabled: view
            values: [],
            indeterminate: isCheckAll === "indeterminate" && true,
            checked: isCheckAll === "checked" && true,
            disableDropdown: true,
            hiddenDropdown: true,
            onCheckAll: (event: any) => onCheckAll(event.target),
            width: 50,
            sortable: false,
        },
        {
            id: "id_comment", width: 200, sortable: false, disablePadding: false, align: 'left', label: t("TERM_PAYMENT_NAME_SURNAME")
        },
        {
            id: "subject_name", disablePadding: false, width: 140, align: "center", label: t("TERM_PAYMENT_NICKNAME")
        },

        {
            id: "detail", disablePadding: false, align: "center", width: 140, label: t("TERM_PAYMENT_LEVEL")
        },
        {
            id: "status", disablePadding: false, align: "center", width: 141, label: t("TERM_PAYMENT_FACULTY")
        },
        {
            id: "status", disablePadding: false, align: "center", width: 200, label: t("TERM_PAYMENT_STUDENT_ID")
        },
        {
            id: "status", disablePadding: false, align: "center", width: 200, label: t("TERM_PAYMENT_PAYMENT_LINK")
        },
        {
            id: "status", disablePadding: false, align: "center", width: 250, label: t("TERM_PAYMENT_STATUS")
        },
        {
            id: "action", disablePadding: false, align: "left", padding: "0 8px", width: 80, class: matches && data?.length > 0, label: ""
        },
    ];
    const renderData = (objData: any, no: any) => {
        no = page * pageLimit - pageLimit + no + 1
        const {
            full_name,
            faculty_name,
            degree_name,
            middle_name,
            create_name,
            created_date,
            url_payment_term,
            student_no,
            admission_status,
            id_admission_student

        } = objData;
        const rowCheck = _.some(
            isChecks,
            (i: any) => Number(i?.id_admission_student) === Number(id_admission_student)
        );
        const objRenderData = {
            key: no,
            id: no,
            obj: objData,
            rowSelect: rowCheck,
            columns: [
                {
                    option: "CHECKBOX",
                    align: "center",
                    label: id_admission_student,
                    disabled: admission_status !== "INTERVIEW_SUCCESS"
                },
                { option: "TEXT", align: "left", label: full_name || "-" },
                {
                    option: "TEXT",
                    align: "center",
                    label: middle_name || "-",
                },

                {
                    option: "TEXT",
                    align: "center",
                    label: degree_name || "-",
                },
                {
                    option: "TEXT",
                    align: "center",
                    label: faculty_name || "-",
                },

                {
                    option: "COMPONENT",
                    align: "center",
                    component: <>
                        <InputTextField value={student_no} disabled={isChecks.length > 0 ? isChecks.find((q) => Number(q?.id_admission_student) !== Number(id_admission_student)) : true} onChange={(e) => {
                            setIsChecks((prevData) =>
                                prevData.map((q) =>
                                    Number(q?.id_admission_student) === Number(id_admission_student)
                                        ? {
                                            ...q,
                                            student_no: e.target.value
                                        }
                                        : q
                                )
                            );
                            setData((prevData) =>
                                prevData.map((q) =>
                                    Number(q?.id_admission_student) === Number(id_admission_student)
                                        ? {
                                            ...q,
                                            student_no: e.target.value
                                        }
                                        : q
                                )
                            );
                        }} />
                    </>,
                },
                {
                    option: "COMPONENT",
                    align: "center",
                    component: <>
                        <InputTextField disabled={isChecks.length > 0 ? isChecks.find((q) => Number(q?.id_admission_student) !== Number(id_admission_student)) : true} value={url_payment_term || ''} onChange={(e) => {
                            setIsChecks((prevData) =>
                                prevData.map((q) =>
                                    Number(q?.id_admission_student) === Number(id_admission_student)
                                        ? {
                                            ...q,
                                            url_payment_term: e.target.value
                                        }
                                        : q
                                )
                            );
                            setData((prevData) =>
                                prevData.map((q) =>
                                    Number(q?.id_admission_student) === Number(id_admission_student)
                                        ? {
                                            ...q,
                                            url_payment_term: e.target.value
                                        }
                                        : q
                                )
                            );
                        }} />
                    </>,
                },

                {
                    option: "COMPONENT",
                    align: "center",
                    component: <StatusCustom
                        disableMaxWidth
                        text={renderStatus(admission_status)}
                        type={renderStatus(admission_status)}
                    />,
                },

                {
                    option: "COMPONENT",
                    align: "center",
                    class: matches && data.length > 0,
                    component: <div className='flex justify-center items-center'>
                        <IconButton onClick={() => navigate(routeName.admission.term_payment_detail.replace(':id', `${id_admission_student}`))}>
                            <ArrowForwardIosIcon />
                        </IconButton>
                        {/* <OptionsButtonCustom
                            enableEdit
                            enableView
                            enableDelete
                            onViewClick={() => handleGetOneDetail(id_comment, 'VIEW')}
                            onEditClick={() => handleGetOneDetail(id_comment, 'EDIT')}
                            onDeleteClick={() => handleDeleteList(id_comment)}
                        /> */}
                    </div>
                },
            ],
        };
        return <TableRowCommon
            {...objRenderData}
            onCheck={(event) => onCheck(event.target)}

        />;
    };


    const handleGetData = useCallback(async () => {
        let query: any = {
            page: page,
            limit: pageLimit
        }
        if (keyword) query = { ...query, keyword: keyword }
        if (id_degree !== 'ALL') query = { ...query, id_degree: id_degree }
        if (id_faculty !== "ALL") query = { ...query, id_faculty: id_faculty }
        if (status !== "ALL") query = { ...query, admission_status: status }
        dispatch(setLoading());
        await AdmissionAdminApi.listPaymentTerm(query).then((res) => {
            if (res.status < 300) {
                setData(res.data?.data?.items || []);
                setTotalItems(res.data?.data?.meta?.totalItems || 0)
            }
        }).catch((err) => {
            console.log(err)
        }).finally(() => {
            dispatch(unsetLoading());
        })
    }, [page, pageLimit, status, keyword, id_degree, id_faculty])

    useEffect(() => {
        handleGetData()
    }, [handleGetData])
    const getDegree = async () => {
        await degreeApi.getDegree().then((res) => {
            if (res.status < 300) {
                setDegree(res.data?.data || []);
            }
        }).catch((err) => {
            console.log(err)
        })
    }
    const getFaculty = async () => {
        await facultyApi.getFaculty().then((res) => {
            if (res.status < 300) {
                setFaculty(res.data?.data || []);
            }
        }).catch((err) => {
            console.log(err)
        })
    }

    useEffect(() => {
        getDegree()
        getFaculty()
    }, [])
    const handleSubmit = async () => {
        if(isChecks?.filter((x) => !x?.student_no).length > 0){
            return alertError(t('TERM_PAYMENT_ENTER_STUDENT_ID'))
        }
        if(isChecks?.filter((x) => !x?.url_payment_term).length > 0){
            return alertError(t('TERM_PAYMENT_ENTER_PAYMENT_LINK'))
        }
        const body = isChecks?.map((item: any) => {
            return {
                id_admission_student: item?.id_admission_student,
                student_no: item?.student_no,
                url_payment_term: item?.url_payment_term
            }
        })
        dispatch(setLoading());
        await AdmissionAdminApi.postPaymentTerm(body)
            .then((res) => {
                if (res.status < 300) {
                    alertSuccess(t("TERM_PAYMENT_SAVE"), t("TERM_PAYMENT_SAVE_SUCCESS"));
                    handleGetData()
                    handleCloseModal()
                    // navigate(routeName.admission.ManagePayment)
                }
            })
            .catch((err) => {
                console.log(err);
                swalError(err?.response?.data?.message || t('เกิดข้อผิดพลาด'))
            })
            .finally(() => {
                dispatch(unsetLoading());
            });
    }

        const handleDownloadFile = async (type?:string) => {
             let query: any = {
                page: page,
                limit: pageLimit,
                sortType: sortType,
                sortBy: sortBy
            }
            if (keyword) query = { ...query, search: keyword }
            if (type) query = { ...query, type: type }
            if (status !== 'ALL') query = { ...query, admission_status: status }
            if (startDate) query = { ...query, start_date: moment(startDate).format("YYYY-MM-DD") }
            if (endDate) query = { ...query, end_date: moment(endDate).format("YYYY-MM-DD") }
            if (id_degree !== 'ALL') query = { ...query, id_degree: id_degree }
            if (id_faculty !== "ALL") query = { ...query, id_faculty: id_faculty }
            dispatch(setLoading());
        
            await AdmissionAdminApi.report_admission_payment_term(query)
              .then((res) => {
                if (res.status < 300) {
                  const response = res.data;
        
                  // Get the content type from the server's response headers
                  const contentType = res.headers["content-type"];
        
                  // Create a Blob with the content type from the response
                  const blob = new Blob([response], { type: contentType });
        
                  // Extract file extension based on content type
                  const fileExtension = getFileExtension(contentType || "");
        
                  // Generate a filename with the correct extension (you can also modify this to use a custom name)
                  const fileName = `${"report-advisor" + new Date().getTime()
                    }.${fileExtension}`;
        
                  // Save the file
                  saveAs(blob, fileName);
                }
              })
              .catch((error) => console.log(error))
              .finally(() => dispatch(unsetLoading()));
          };

    return {
        page,
        pageLimit,
        setPage,
        setPageLimit,
        sortBy,
        sortType,
        handleRequestSort,
        headCells,
        renderData,
        data,
        totalItems,
        setKeyword,
        handleChangeDateRange,
        date_range,
        handleClearDateRange,
        handleSubmit,
        degree,
        faculty,
        id_degree,
        set_id_degree,
        id_faculty,
        set_id_faculty,
        // url_payment_term,
        setShowModal,
        showModal,
        student_no,
        set_student_no,
        // set_url_payment_term,
        handleCloseModal,
        status, 
        set_status,
        handleDownloadFile
    }
}

export default ManageState